import { render, staticRenderFns } from "./VxInputGroup.vue?vue&type=template&id=00433e15&functional=true&"
import script from "./VxInputGroup.vue?vue&type=script&lang=js&"
export * from "./VxInputGroup.vue?vue&type=script&lang=js&"
import style0 from "./VxInputGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00433e15')) {
      api.createRecord('00433e15', component.options)
    } else {
      api.rerender('00433e15', component.options)
    }
    module.hot.accept("./VxInputGroup.vue?vue&type=template&id=00433e15&functional=true&", function () {
      api.rerender('00433e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-input-group/VxInputGroup.vue"
export default component.exports